<template>
	<v-dialog v-model="showDialog" persistent max-width="290">
		<v-card class="pa-4">
			<v-card-title>Select a project</v-card-title>
			<v-card-text>
				<v-select
					v-model="project"
					:items="
						allProjects.sort((a, b) => (a.Name > b.Name ? 1 : -1))
					"
					label="Project"
					item-text="Name"
					item-value="Id"
				>
				</v-select>
			</v-card-text>
			<v-card-actions
				style="display: flex; justify-content: center; width: 100%"
			>
				<v-btn @click="onCancel">Cancel</v-btn>
				<v-btn @click="onSubmit" class="primary">Submit</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
import {
	ProjectContextActions,
	ClientContextActions,
} from '../../store/actions';
import { ProjectContextGetters } from '../../store/getters';
import { mapGetters } from 'vuex';
export default {
	name: 'SelectProjectModal',
	props: {
		showDialog: Boolean,
	},
	data() {
		return {
			project: null,
		};
	},
	computed: {
		...mapGetters({
			allProjects: [ProjectContextGetters.PROJECTS],
			selectedProjectStore: [ProjectContextGetters.SELECTED_PROJECT],
		}),
		selectedProject() {
			if (this.project) {
				let result = this.allProjects.filter(
					(t) => t.Id == this.project
				);
				return result;
			}
			return null;
		},
	},
	mounted() {
		let initProj = this.allProjects.find(
			(p) => p.Id === this.selectedProjectStore.Id
		);
		if (!initProj) {
			initProj = this.allProjects[0];
		}
		this.project = initProj.Id;
	},
	methods: {
		onCancel() {
			this.$emit('cancel');
		},
		onSubmit() {
			this.$store
				.dispatch(
					ProjectContextActions.UPDATE_SELECTED_PROJECT,
					this.selectedProject[0]
				)
				.then(() => {
					this.$router.push('/homepage');
					this.$store.dispatch(
						ClientContextActions.RELOAD_CLIENT_CONTEXT
					);
				});
			this.$emit('cancel');
		},
	},
};
</script>
